import { STATUS_MAPPING } from "./config";
  
  export const getRecipients = (news) => {
    return news?.recipients_flg === 1
      ? ["All citizens"]
      : news?.wards?.map((ward) => `${ward?.ward_code} - ${ward?.region_name}`);
  };
  
  export const formatBasicDetails = (selectedNews) => {
    return [
      {
        key: "Status",
        value: [STATUS_MAPPING[selectedNews?.status]],
        chip: true,
      },
      {
        key: "Image caption", 
        value: selectedNews?.image_caption,
      },
      {
        key: "Author",
        value: selectedNews?.author,
        avatar: true,
      },
      {
        key: "Recipients",
        value: getRecipients(selectedNews),
        chip: true,
      },
      {
        key: "Source",
        value: selectedNews?.source,
      },
      {
        key: "Created date",
        value: selectedNews?.activity && selectedNews?.activity[0]?.date,
      },
      {
        key: "Expiry date & time",
        value: selectedNews?.expirydatetime, 
      },
    ];
  };

  const getNewsStatus = (type) => {
    switch (type) {
      case 'reject':
        return 3;
      case 'schedule':
        return 2;
      case 'publish':
        return 4;
      default:
        return 0;
    }
  };
  
  export const createNewsForm = (selectedNews, type) => {
    return {
      news_id: selectedNews?.id,
      status: getNewsStatus(type)
    };
  };